import { HttpService } from '@/services/http.service';

export default {
    async store(trainingItem) {
        return await HttpService.httpPost(`/item-downloads`, trainingItem);
    },
}
